import "./StorageQuotaStyles.css";
const SpaceQuotaInfo2 =({data,closeSpaceQuotaPopUp})=>{
    const { message = '', used_space = 0, quota = 0, remaining = 0 } = data || {};


const percentUsed = quota > 0 ? Math.min(100, Math.round((used_space / quota) * 100)) : 0;


function formatBytes(bytes) {
if (!bytes && bytes !== 0) return '-';
const thresh = 1024;
if (Math.abs(bytes) < thresh) return bytes + ' B';
const units = ['KB', 'MB', 'GB', 'TB', 'PB'];
let u = -1;
let b = bytes;
do {
b /= thresh;
u++;
} while (Math.abs(b) >= thresh && u < units.length - 1);
return b.toFixed(1) + ' ' + units[u];
}
 return(<>
     <div className="storage-alert" >
<div className="alert-icon">
<svg xmlns="http://www.w3.org/2000/svg" className="icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
</svg>
</div>


<div className="alert-content">
<div className="alert-header">
<h3>Files Storage Info </h3>
<button
className="btn btn-upgrade"
onClick={() => {}}
>
Upgrade
</button>
<span>{percentUsed}% used</span>
</div>



<div className="progress-container">
<div className="progress-bar-bg" style={{display:"flex",justifyContent:"left"}}>
<div
className={`progress-bar ${percentUsed >= 100 ? 'full' : ''}`}
style={{ width: `${percentUsed}%` }}
/>
</div>
<div className="progress-info">
<div>Used: <strong>{formatBytes(used_space)}</strong></div>
<div>Quota: <strong>{formatBytes(quota)}</strong></div>
<div>Remaining: <strong>{formatBytes(remaining)}</strong></div>
</div>
</div>




</div>
</div>
 </>)   
}


export default SpaceQuotaInfo2;